module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainProduct__price"
  }, [_c('span', {
    class: [_vm.pathProduct.newPrice == '' ? '' : 'mainProduct__oldPrice']
  }, [_vm._v("\n    " + _vm._s(_vm._f("currency")(_vm.pathProduct.price)) + " \n  ")]), _vm._v(" "), (_vm.pathProduct.newPrice !== '') ? _c('span', {
    staticClass: "mainProduct__newPrice"
  }, [_vm._v("\n    " + _vm._s(_vm._f("currency")(_vm.pathProduct.newPrice)) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f17177d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainPrice.vue
// module id = 52
// module chunks = 0